//Login
const REACT_APP_AUTH_HOST = 'https://api.mondelez.smartmob.corebiz.ag';
const REACT_APP_AUTH_HOST_DEV = 'https://api-dev.mondelez.smartmob.corebiz.ag';
// const REACT_APP_AUTH_HOST_DEV = 'https://api.mondelez.smartmob.corebiz.ag';

//API GraphQL CMS
const REACT_APP_CMS_GRAPHQL_HOST =
	'https://cms-api.mondelez.smartmob.corebiz.ag/graphql';
const REACT_APP_CMS_GRAPHQL_HOST_DEV =
	'https://cms-api-dev.mondelez.smartmob.corebiz.ag/graphql';
// 'https://cms-api.mondelez.smartmob.corebiz.ag/graphql';

//API REST CMS
const REACT_APP_CMS_HOST = 'https://cms-api.mondelez.smartmob.corebiz.ag';
const REACT_APP_CMS_HOST_DEV =
	'https://cms-api-dev.mondelez.smartmob.corebiz.ag';
// 'https://cms-api.mondelez.smartmob.corebiz.ag';

export function return_REACT_APP_AUTH_HOST() {
	//ambiente de desenvolvimento
	if (document.location.hostname.includes('localhost')) {
		return REACT_APP_AUTH_HOST_DEV;
	}

	// ================= CLIENTES =================

	//DEV
	if (document.location.hostname.includes('cms-dev.mondelez')) {
		return REACT_APP_AUTH_HOST_DEV;
	}

	//PROD
	if (document.location.hostname.includes('cms.mondelez')) {
		return REACT_APP_AUTH_HOST;
	}

	return REACT_APP_AUTH_HOST_DEV;
}

export function return_REACT_APP_CMS_GRAPHQL_HOST() {
	//ambiente de desenvolvimento
	if (document.location.hostname.includes('localhost')) {
		return REACT_APP_CMS_GRAPHQL_HOST_DEV;
	}

	//homolog
	if (document.location.hostname.includes('cms-dev.mondelez')) {
		return REACT_APP_CMS_GRAPHQL_HOST_DEV;
	}

	//prod
	if (document.location.hostname.includes('cms.mondelez')) {
		return REACT_APP_CMS_GRAPHQL_HOST;
	}

	return REACT_APP_CMS_GRAPHQL_HOST_DEV;
}

export function return_REACT_APP_CMS_HOST() {
	//ambiente de desenvolvimento
	if (document.location.hostname.includes('localhost')) {
		return REACT_APP_CMS_HOST_DEV;
	}

	//homolog
	if (document.location.hostname.includes('cms-dev.mondelez')) {
		return REACT_APP_CMS_HOST_DEV;
	}
	//prod
	if (document.location.hostname.includes('cms.mondelez')) {
		return REACT_APP_CMS_HOST;
	}

	return REACT_APP_CMS_HOST_DEV;
}
